export const ROUTE_STATE_LABELS: Record<string, string> = {
  draft: "Draft",
  assigned: "Assigned",
  loaded: "Loaded",
  in_progress: "In Progress",
  done: "Done",
  cancelled: "Cancelled",
};

export const DELIVERY_STATUS_LABELS: Record<string, string> = {
  in_progress: "In Progress",
  delivered: "Delivered",
  not_delivered: "Not Delivered",
};

export const DRIVER_STATUS_LABELS: Record<string, string> = {
  not_arrived: "Not Arrived",
  arrived: "Arrived",
  departed: "Departed",
};

export function formatOdooTime(value?: number | string | null | false): string {
  if (value == null || value === "" || value === false) {
    return "—";
  }

  if (typeof value === "string") {
    if (/^\d{2}:\d{2}$/.test(value)) {
      return value;
    }
    const parsed = Number(value);
    if (Number.isNaN(parsed)) {
      return value;
    }
    value = parsed;
  }

  const hours = Math.floor(value);
  const minutes = Math.round((value - hours) * 60);
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}

export function getRelationName(
  value: unknown,
  fallback = "—"
): string {
  if (!value || value === false) {
    return fallback;
  }
  if (typeof value === "string") {
    return value;
  }
  if (Array.isArray(value) && typeof value[1] === "string") {
    return value[1];
  }
  if (typeof value === "object" && typeof (value as { name?: string }).name === "string") {
    return (value as { name: string }).name;
  }
  return fallback;
}

export function getRouteDisplayLabel(route: {
  display_name?: string;
  name: string;
  state?: string;
}): string {
  const displayName = route.display_name?.trim();
  if (displayName) {
    return displayName;
  }
  return route.state ? `${route.name} (${route.state})` : route.name;
}

export function getRelationId(value: unknown): number | null {
  if (value == null || value === false) {
    return null;
  }
  if (typeof value === "number") {
    return value;
  }
  if (Array.isArray(value) && typeof value[0] === "number") {
    return value[0];
  }
  if (typeof value === "object" && typeof (value as { id?: number }).id === "number") {
    return (value as { id: number }).id;
  }
  return null;
}
